import Layout from 'antd/lib/layout';
import config from '../config';

export const PageFooter = () => {
    return (
        <Layout.Footer className="footer">
            <span>(C) Enersponse, LLC. All rights reserved.</span>
            <br />
            <span>
                Need help? Email <a href={`mailto:${config.SUPPORT_EMAIL}`}>{config.SUPPORT_EMAIL}</a> or call +1 (949) 734-0043
            </span>
        </Layout.Footer>
    );
};
